import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faBuilding } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles';
import { EmpresaModalProps } from '../../../../pages/Cadastros/Empresas/types';
import { Modal } from '../../../interface/Modal';

const EmpresaModal: React.FC<EmpresaModalProps> = ({
  isOpen,
  onClose,
  formData,
  handleChange,
  handleSubmit,
}) => {
  if (!isOpen) return null;

  const editando = Boolean(formData.codigo);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editando ? `Empresa ${formData.identificador}` : 'Nova empresa'}
      headerIcon={faBuilding}
      size="large"
    >
      <S.Form onSubmit={handleSubmit}>
        <S.FormGroup>
          <S.Label htmlFor="identificador">Identificador*</S.Label>
          <S.Input
            id="identificador"
            name="identificador"
            value={formData.identificador}
            onChange={handleChange}
            disabled={editando}
            required
          />
          <S.Ajuda>
            É o valor que já identifica a empresa nos usuários, notas e
            entregas (ex: <strong>minassal</strong>). Não muda depois de criado.
          </S.Ajuda>
        </S.FormGroup>

        <S.FormGroup>
          <S.Label htmlFor="nome">Nome</S.Label>
          <S.Input
            id="nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
          />
        </S.FormGroup>

        <S.FormGroup>
          <S.Label htmlFor="url_erp">URL da API do ERP</S.Label>
          <S.Input
            id="url_erp"
            name="url_erp"
            value={formData.url_erp}
            onChange={handleChange}
            placeholder="https://aws.adasistemas.com.br/sistema/distribuidora/api/index.php"
          />
          <S.Ajuda>
            Endereço do <em>index.php</em> da API do ERP daquele cliente. Sem
            ele, o app não sincroniza as notas do dia.
          </S.Ajuda>
        </S.FormGroup>

        <S.FormGroup>
          <S.Label htmlFor="banco_erp">Banco do ERP</S.Label>
          <S.Input
            id="banco_erp"
            name="banco_erp"
            value={formData.banco_erp}
            onChange={handleChange}
            placeholder="minassal"
          />
          <S.Ajuda>Vai no cabeçalho <strong>Db</strong> das chamadas ao ERP.</S.Ajuda>
        </S.FormGroup>

        <S.FormGroup>
          <S.Label htmlFor="token_erp">Chave de acesso ao ERP</S.Label>
          <S.Input
            id="token_erp"
            name="token_erp"
            value={formData.token_erp}
            onChange={handleChange}
            placeholder="deixe como está para manter a chave atual"
          />
          <S.Ajuda>
            A chave é a mesma para todos os clientes e já vem preenchida pela
            configuração global. Preencha aqui só para dar a esta empresa uma
            chave própria. O valor aparece mascarado; deixando como está, a
            chave gravada é preservada.
          </S.Ajuda>
        </S.FormGroup>

        <S.FormGroup>
          <S.CheckboxLinha htmlFor="ativo">
            <input
              id="ativo"
              name="ativo"
              type="checkbox"
              checked={formData.ativo}
              onChange={handleChange}
            />
            Empresa ativa
          </S.CheckboxLinha>
          <S.Ajuda>Empresa inativa não sincroniza notas com o ERP.</S.Ajuda>
        </S.FormGroup>

        <S.ButtonContainer>
          <S.SaveButton type="submit">
            <FontAwesomeIcon icon={faSave} />
            Salvar
          </S.SaveButton>
        </S.ButtonContainer>
      </S.Form>
    </Modal>
  );
};

export default EmpresaModal;
